<div class="modal-header-row">
    <h2 class="fs-4 fw-bold mb-0">Editar visibilidad de Contacto</h2>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Cerrar"></button>
</div>

<div class="info-container">
    <div class="content-item">
        <div class="content-item-info">
            <i class="fas fa-envelope content-item-icon" aria-hidden="true"></i>
            <div>
                <h3 class="fw-semibold mb-0">Ocultar contacto</h3>
                <p class="content-item-hint mb-0">Correo, teléfono y sitio web no serán visibles para otros usuarios</p>
            </div>
        </div>
        <div class="toggle-switch">
            <input type="checkbox" id="hideContact" class="toggle-switch-checkbox" [(ngModel)]="b_ocultarcontacto" />
            <label for="hideContact" class="toggle-switch-label">
                <span class="toggle-switch-inner" data-yes="Sí" data-no="No"></span>
                <span class="toggle-switch-switch"></span>
            </label>
        </div>
    </div>

    <div class="content-item">
        <div class="content-item-info">
            <i class="fas fa-share-nodes content-item-icon" aria-hidden="true"></i>
            <div>
                <h3 class="fw-semibold mb-0">Ocultar redes</h3>
                <p class="content-item-hint mb-0">Tus redes sociales no serán visibles para otros usuarios</p>
            </div>
        </div>
        <div class="toggle-switch">
            <input type="checkbox" id="hideSocial" class="toggle-switch-checkbox" [(ngModel)]="b_ocultarredes" />
            <label for="hideSocial" class="toggle-switch-label">
                <span class="toggle-switch-inner" data-yes="Sí" data-no="No"></span>
                <span class="toggle-switch-switch"></span>
            </label>
        </div>
    </div>
</div>

<div class="modal-footer-row">
    <button type="button" class="btn btn-primary" (click)="saveVisibility()">Guardar Visibilidad</button>
</div>